'use strict';
(() => {
try {
const root = document.querySelector('[data-cm-dulles-story]');
if (!root) return;
const byId = id => root.querySelector('#' + id);

  const dialog = byId('cm-ds-color-viewer');
  const stage = byId('cm-ds-color-viewer-stage');
  const image = byId('cm-ds-color-viewer-image');
  const name = byId('cm-ds-color-viewer-name');
  const zoomButton = byId('cm-ds-color-viewer-zoom');
  const closeButton = byId('cm-ds-color-viewer-close');
  const detailDialog = byId('cm-ds-detail-dialog');
  const triggers = Array.from(root.querySelectorAll('[data-color-view]'));
  if (!dialog || !stage || !image || !name || !zoomButton || !closeButton || !triggers.length) return;
  const sized=(url,width)=>{const source=new URL(url,location.href);source.searchParams.set('width',width);return source.href;};
  const galleryURL=location.href;
  const colors = triggers.map(button => {
    const hero = button.querySelector('img');
    return {
      key: button.dataset.colorView,
      name: button.closest('.color-card').querySelector('h3').textContent.trim(),
      description: button.closest('.color-card').querySelector('.color-description')?.textContent.trim() || '',
      button, hero, selected: 0,
      photos: [{ src: hero.getAttribute('src'), alt: hero.alt, label: '写真',
        width: Number(hero.getAttribute('width')), height: Number(hero.getAttribute('height')) }]
    };
  });
  const copy = document.createElement('p');
  copy.className = 'color-viewer-copy';
  copy.id = 'cm-ds-color-viewer-copy';
  copy.setAttribute('aria-live', 'polite');
  const photoStrip = document.createElement('div');
  photoStrip.className = 'color-viewer-thumbnails';
  photoStrip.setAttribute('role', 'group');
  photoStrip.setAttribute('aria-label', '表示するカラーの写真を選ぶ');
  stage.after(copy, photoStrip);
  let currentColor = 0;
  let current = 0;
  const counter = document.createElement('span');
  counter.className = 'color-viewer-counter';
  counter.setAttribute('aria-live', 'polite');
  counter.setAttribute('aria-atomic', 'true');
  const switches = document.createElement('div');
  switches.className = 'color-viewer-switches';
  switches.setAttribute('role', 'group');
  switches.setAttribute('aria-label', 'カラーを選ぶ');
  colors.forEach((color, index) => {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = color.name;
    button.setAttribute('aria-label', `${color.name}に切り替える`);
    button.addEventListener('click', () => { currentColor = index; show(0); });
    color.switchButton = button;
    switches.append(button);
  });
  const footer = dialog.querySelector('.color-viewer-controls');
  const navigation = document.createElement('div');
  navigation.className = 'color-viewer-navigation';
  while (footer.firstChild) navigation.append(footer.firstChild);
  navigation.insertBefore(counter, zoomButton);
  footer.append(navigation, switches);
  stage.append(counter);
  const previousButton = byId('cm-ds-color-viewer-prev');
  const nextButton = byId('cm-ds-color-viewer-next');
  previousButton.setAttribute('aria-label', '同じカラーの前の写真');
  nextButton.setAttribute('aria-label', '同じカラーの次の写真');
  previousButton.classList.add('viewer-photo-arrow', 'viewer-photo-arrow--previous');
  nextButton.classList.add('viewer-photo-arrow', 'viewer-photo-arrow--next');
  [previousButton, nextButton].forEach(button => button.addEventListener('pointerdown', event => event.stopPropagation()));
  stage.append(previousButton, nextButton);
  function setPhoto(target, photo) {
    // Remove any responsive source inherited from a hero before changing its source.
    target.removeAttribute('srcset');
    target.removeAttribute('sizes');
    if (photo.width > 0 && photo.height > 0) {
      target.setAttribute('width', String(photo.width));
      target.setAttribute('height', String(photo.height));
    } else {
      target.removeAttribute('width');
      target.removeAttribute('height');
    }
    target.alt = photo.alt;
    target.src = target === image ? photo.src : sized(photo.src, target.classList.contains('cm-ds-thumb-image') ? 128 : 900);
  }
  function selectCard(color, index) {
    color.selected = index;
    if (!color.thumbnails) return;
    const photo = color.photos[index];
    setPhoto(color.hero, photo);
    color.button.setAttribute('aria-label', `${color.name}の${photo.label}を拡大（${index + 1} / ${color.photos.length}）`);
    color.cardCounter.textContent = `${index + 1} / ${color.photos.length}`;
    color.thumbnails.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
  }
  function enhanceCards() {
    colors.forEach(color => {
      const row = document.createElement('div');
      row.className = 'color-photo-selection';
      const strip = document.createElement('div');
      strip.className = 'color-photo-thumbnails';
      strip.setAttribute('role', 'group');
      strip.setAttribute('aria-label', `${color.name}の写真を選ぶ`);
      color.thumbnails = color.photos.map((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'color-photo-thumbnail';
        button.setAttribute('aria-label', `${color.name}：${photo.label}（${index + 1} / ${color.photos.length}）`);
        const thumbnail = document.createElement('img');
        thumbnail.className='cm-ds-thumb-image';
        setPhoto(thumbnail, photo);
        thumbnail.alt = '';
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';
        button.append(thumbnail);
        button.addEventListener('click', () => selectCard(color, index));
        strip.append(button);
        return button;
      });
      color.cardCounter = document.createElement('span');
      color.cardCounter.className = 'color-photo-counter';
      color.cardCounter.setAttribute('aria-live', 'polite');
      color.cardCounter.setAttribute('aria-atomic', 'true');
      row.append(strip, color.cardCounter);
      color.button.insertAdjacentElement('afterend', row);
      selectCard(color, color.selected);
    });
  }
  function parseGallery(data) {
    if (!Array.isArray(data?.colors) || data.colors.length !== colors.length) throw new Error('Invalid colors');
    const seen = new Set();
    return colors.map(color => {
      const entry = data.colors.find(candidate => candidate?.key === color.key);
      if (!entry || seen.has(entry.key) || typeof entry.name !== 'string' || !entry.name.trim() ||
          !Array.isArray(entry.photos) || entry.photos.length === 0) throw new Error('Invalid color');
      seen.add(entry.key);
      return { name: entry.name.trim(), photos: entry.photos.map(photo => {
        if (!photo || typeof photo.src !== 'string' || !photo.src.trim() ||
            typeof photo.alt !== 'string' || !photo.alt.trim() || typeof photo.label !== 'string' || !photo.label.trim() ||
            !Number.isInteger(photo.width) || photo.width <= 0 || !Number.isInteger(photo.height) || photo.height <= 0) {
          throw new Error('Invalid photo');
        }
        const source = new URL(photo.src, galleryURL);
        if (!['http:', 'https:', 'file:'].includes(source.protocol)) throw new Error('Invalid source');
        return { ...photo, src: source.href };
      }) };
    });
  }
  const entries=parseGallery(JSON.parse(root.querySelector('[data-cm-ds-colors]').textContent));
  entries.forEach((entry,index)=>Object.assign(colors[index],entry));
  enhanceCards();
  let returnFocus = null;
  let scroll = 0;
  let bodyStyle = null;
  let locked = false;
  let scale = 1, panX = 0, panY = 0;
  const pointers = new Map();
  let gesture = null;
  let pinched = false;
  function clampPan(value, size, viewport) {
    const limit = Math.max(0, (size - viewport) / 2);
    return Math.max(-limit, Math.min(limit, value));
  }
  function renderZoom() {
    counter.style.bottom = `${Math.max(0, (stage.clientHeight - image.offsetHeight) / 2) + 10}px`;
    const arrowInset = Math.max(0, (stage.clientWidth - image.offsetWidth) / 2) + 10;
    previousButton.style.left = `${arrowInset}px`;
    nextButton.style.right = `${arrowInset}px`;
    panX = clampPan(panX, image.offsetWidth * scale, stage.clientWidth);
    panY = clampPan(panY, image.offsetHeight * scale, stage.clientHeight);
    image.style.transform = `translate(${panX}px, ${panY}px) scale(${scale})`;
    stage.classList.toggle('is-zoomed', scale > 1);
    zoomButton.textContent = scale > 1 ? '全体' : '拡大';
    zoomButton.setAttribute('aria-pressed', String(scale > 1));
    zoomButton.setAttribute('aria-label', scale > 1 ? '写真を全体表示に戻す' : '写真を2倍に拡大');
  }
  function setZoom(value) {
    scale = Math.max(1, Math.min(4, value));
    if (scale === 1) panX = panY = 0;
    renderZoom();
  }
  function resetZoom() {
    scale = 1; panX = panY = 0;
    pointers.clear(); gesture = null; pinched = false;
    stage.classList.remove('is-dragging');
    renderZoom();
  }
  function paintPhotoStrip(color) {
    if (photoStrip.dataset.colorKey !== color.key) {
      const buttons = color.photos.map((photo, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'color-viewer-thumbnail';
        button.setAttribute('aria-label', `${color.name}：${photo.label}（${index + 1} / ${color.photos.length}）`);
        const thumbnail = document.createElement('img');
        thumbnail.src = sized(photo.src, 128);
        thumbnail.alt = '';
        thumbnail.loading = 'lazy';
        thumbnail.decoding = 'async';
        button.append(thumbnail);
        button.addEventListener('click', () => show(index));
        return button;
      });
      photoStrip.replaceChildren(...buttons);
      photoStrip.dataset.colorKey = color.key;
    }
    const buttons = Array.from(photoStrip.children);
    buttons.forEach((button, index) => button.setAttribute('aria-pressed', String(index === current)));
    const selected = buttons[current];
    if (selected) {
      const left = selected.offsetLeft - photoStrip.offsetLeft - (photoStrip.clientWidth - selected.clientWidth) / 2;
      photoStrip.scrollTo({left: Math.max(0, left), behavior: 'instant'});
    }
  }
  function show(index) {
    const color = colors[currentColor];
    current = ((index % color.photos.length) + color.photos.length) % color.photos.length;
    resetZoom();
    setPhoto(image, color.photos[current]);
    name.textContent = color.name;
    copy.textContent = color.description;
    copy.hidden = !color.description;
    if (color.description) dialog.setAttribute('aria-describedby', 'cm-ds-color-viewer-copy');
    else dialog.removeAttribute('aria-describedby');
    paintPhotoStrip(color);
    counter.textContent = `${current + 1} / ${color.photos.length}`;
    previousButton.disabled = nextButton.disabled = color.photos.length < 2;
    colors.forEach((entry, i) => entry.switchButton.setAttribute('aria-pressed', String(i === currentColor)));
    selectCard(color, current);
  }

  function restore(){resetZoom();root.cmDS.restore(dialog);}
  function close(){if(dialog.open){dialog.close();restore();}}
  function open(index,trigger){currentColor=index;show(colors[index].selected);root.cmDS.open(dialog,trigger);renderZoom();closeButton.focus({preventScroll:true});}
  triggers.forEach((button, index) => button.addEventListener('click', () => open(index, button)));
  closeButton.addEventListener('click', close);
  dialog.addEventListener('cancel', event => { event.preventDefault(); close(); });
  dialog.addEventListener('close', () => { if (!dialog.open) restore(); });
  byId('cm-ds-color-viewer-prev').addEventListener('click', () => show(current - 1));
  byId('cm-ds-color-viewer-next').addEventListener('click', () => show(current + 1));
  zoomButton.addEventListener('click', () => setZoom(scale > 1 ? 1 : 2));
  dialog.addEventListener('keydown', event => {
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();
      show(current + (event.key === 'ArrowRight' ? 1 : -1));
    }
    if (['+', '=', '-', '0'].includes(event.key)) {
      event.preventDefault();
      if (event.key === '0') resetZoom();
      else setZoom(scale + (event.key === '-' ? -.5 : .5));
    }
  });
  image.addEventListener('load', renderZoom);
  new ResizeObserver(() => { if (dialog.open) renderZoom(); }).observe(stage);
  stage.setAttribute('aria-label', '写真をタップで拡大。全体表示では左右スワイプで同じカラーの写真切替。拡大中はドラッグで移動');
  stage.addEventListener('dragstart', event => event.preventDefault());
  function startGesture() {
    const points = [...pointers.values()];
    if (points.length >= 2) {
      pinched = true;
      gesture = { distance: Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y), scale };
    } else if (points.length === 1) {
      gesture = { x: points[0].x, y: points[0].y, panX, panY, scale, moved: false };
    } else gesture = null;
  }
  stage.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    if (pointers.size === 0) pinched = false;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    stage.setPointerCapture(event.pointerId);
    startGesture();
  });
  stage.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
    const points = [...pointers.values()];
    if (points.length >= 2) {
      setZoom(gesture.scale * Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y) / Math.max(1, gesture.distance));
    } else {
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (Math.hypot(dx, dy) > 6) gesture.moved = true;
      if (scale > 1) {
        panX = gesture.panX + dx; panY = gesture.panY + dy;
        stage.classList.toggle('is-dragging', gesture.moved);
        renderZoom();
      }
    }
  });
  stage.addEventListener('pointerup', event => {
    if (!pointers.has(event.pointerId)) return;
    const previous = gesture;
    const single = pointers.size === 1 && !pinched && previous;
    pointers.delete(event.pointerId);
    if (single) {
      const dx = event.clientX - previous.x, dy = event.clientY - previous.y;
      if (previous.scale === 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.25) show(current + (dx < 0 ? 1 : -1));
      else if (!previous.moved && Math.hypot(dx, dy) < 6) setZoom(scale > 1 ? 1 : 2);
    }
    stage.classList.remove('is-dragging');
    startGesture();
  });
  function cancelPointer(event) {
    pointers.delete(event.pointerId); pinched = true; startGesture();
    stage.classList.remove('is-dragging');
  }
  stage.addEventListener('pointercancel', cancelPointer);
  stage.addEventListener('lostpointercapture', event => { if (pointers.has(event.pointerId)) cancelPointer(event); });
} catch(error) { console.error("Dulles color: " ,error); }
})();
